/** The help story behind every catalogue field's "Learn more" (one place to repoint). */
import type { HelpStoryId } from '@/help/registry.gen';

export const CATALOGUE_STORY: HelpStoryId = 'catalogue-sync';
